import React from "react";
import AwardFormPage from "../components/awards/AwardFormPage";

const AwardEdit = () => <AwardFormPage mode="edit" />;

export default AwardEdit;
